var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { CanvasProvider } from 'app/image/canvas/provider/dom';
import { drawBitmap } from 'app/image/rasterize/drawBitmap';
// -----------------------
// Load image
// -----------------------
const loadImageElement = (source) => __awaiter(void 0, void 0, void 0, function* () {
    if ('url' in source) {
        const { url } = source;
        if (!url) {
            return Promise.reject(new Error('Empty image url'));
        }
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onerror = reject;
            img.onload = () => resolve(img);
            img.src = url;
        });
    }
    return Promise.reject(new Error('Invalid data type'));
});
export const renderToImage = (renderJob) => __awaiter(void 0, void 0, void 0, function* () {
    const { image, blurredImage, markup, opts: { watermark: watermarkSource }, } = renderJob;
    let slideBlurImg;
    const slideImage = yield loadImageElement(image.source);
    // draw blur
    const hasBlurs = markup.blurs.length > 0;
    if (hasBlurs) {
        if (!blurredImage) {
            throw new Error('Missing blurred image');
        }
        slideBlurImg = yield loadImageElement(blurredImage.source);
    }
    // images
    const images = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const [id, img] of Object.entries(renderJob.images)) {
        // eslint-disable-next-line no-await-in-loop
        images[id] = yield loadImageElement(img.source);
    }
    // watermark
    let watermark;
    if (watermarkSource) {
        const { source } = watermarkSource, props = __rest(watermarkSource, ["source"]);
        const watermarkImg = yield loadImageElement(source);
        watermark = Object.assign(Object.assign({}, props), { image: watermarkImg });
    }
    // render
    const provider = new CanvasProvider();
    const canvas = yield drawBitmap(provider, renderJob, slideImage, images, slideBlurImg, watermark);
    let result;
    canvas.style.position = 'absolute';
    canvas.style.display = 'none';
    canvas.style.top = '0px';
    canvas.style.left = '0px';
    canvas.style.width = '80vw';
    const { body } = document;
    body.appendChild(canvas);
    try {
        const { output } = renderJob;
        result = yield new Promise((resolve, reject) => {
            var _a;
            canvas.toBlob(blob => {
                if (blob) {
                    resolve(blob);
                }
                else {
                    reject(new Error('Export error'));
                }
            }, output.type, (_a = output.quality) !== null && _a !== void 0 ? _a : 90);
        });
    }
    catch (err) {
        console.error(err);
        result = null;
    }
    body.removeChild(canvas);
    provider.dispose();
    return result;
});
